import { Wizard, WizardStep } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import CompanyPaidItems from './_CompanyPaidItems'
import ReviewAndSubmit from './_ReviewAndSubmit'
import TripDetails from './_TripDetails'

interface PerDiemWizardModalProps {
  onClose: () => void
}

interface WizardData {
  // TODO: Add wizard data structure
}

export const PerDiemWizardModal = ({ onClose }: PerDiemWizardModalProps) => {
  const initialData: WizardData = {}

  const tripDetailsStep: WizardStep<WizardData> = {
    title: i18n.t('expenses_v2.forms.germany_per_diem_modal.steps.step1.title'),
    nextText: i18n.t('common.next'),
    render: () => <TripDetails />,
    isCompleted: () => true,
  }

  const companyPaidItemsStep: WizardStep<WizardData> = {
    title: i18n.t('expenses_v2.forms.germany_per_diem_modal.steps.step2.title'),
    nextText: i18n.t('common.next'),
    render: () => <CompanyPaidItems />,
    isCompleted: () => true,
  }

  const reviewSubmitStep: WizardStep<WizardData> = {
    title: i18n.t('expenses_v2.forms.germany_per_diem_modal.steps.step3.title'),
    nextText: i18n.t('common.save'),
    render: () => <ReviewAndSubmit />,
    isCompleted: () => true,
  }

  const handleSubmit = async () => {
    // TODO: Implement submit logic
  }

  return (
    <Wizard.Modal
      modal
      title={i18n.t('expenses_v2.forms.germany_per_diem_modal.title')}
      steps={[tripDetailsStep, companyPaidItemsStep, reviewSubmitStep]}
      initialData={initialData}
      onSubmit={handleSubmit}
      onClose={onClose}
      size="large"
    />
  )
}
